import { API, Auth } from 'aws-amplify'
import { API_NAME, IS_LOCAL } from '@/constants'

let localDevices
if (IS_LOCAL) {
  localDevices = require('@/fixture/devices.json')
}

async function getAuthOption() {
  const token = (await Auth.currentSession()).getIdToken().getJwtToken()
  return {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json;charset=utf-8;',
      Authorization: `Bearer ${token}`
    }
  }
}

// Device
export const getDevices = async provider => {
  if (IS_LOCAL) {
    return localDevices
  }
  const option = await getAuthOption()
  return API.get(API_NAME, `/devices?provider=${provider}`, option)
}

export const getDevice = async (provider, deviceId) => {
  if (IS_LOCAL) {
    return
  }
  const option = await getAuthOption()
  return API.get(API_NAME, `/device/${deviceId}?provider=${provider}`, option)
}

// UserDevice
export const postUserDevice = async (provider, id) => {
  if (IS_LOCAL) {
    return
  }
  const option = await getAuthOption()
  option.body = {
    device_id: id,
    provider: provider
  }
  return API.post(API_NAME, '/device', option)
}

export const putUserDevice = async (
  provider,
  id,
  IsNotificationDisabled,
  alertDisabledTime
) => {
  if (IS_LOCAL) {
    return
  }
  const option = await getAuthOption()
  option.body = {
    provider: provider,
    device_id: id,
    is_notification_disabled: IsNotificationDisabled,
    alert_disabled_time: Number(alertDisabledTime)
  }
  return API.put(API_NAME, '/device', option)
}

export const deleteUserDevice = async (provider, id) => {
  if (IS_LOCAL) {
    return
  }
  const option = await getAuthOption()
  option.body = {
    provider: provider,
    device_id: id
  }
  return API.del(API_NAME, '/device', option)
}

// provider
export const getProvider = async ({ type, value }) => {
  return API.get(API_NAME, `/provider?type=${type}&value=${value}`)
}

// Logger
export const postLogger = async body => {
  if (IS_LOCAL) {
    return
  }
  const option = await getAuthOption()
  option.body = body
  return API.post(API_NAME, '/logger', option)
}

// device picture
export const getDevicePictures = async (provider, deviceId) => {
  if (IS_LOCAL) {
    return
  }
  const option = await getAuthOption()
  return API.get(
    API_NAME,
    `/device/${deviceId}/pictures?provider=${provider}`,
    option
  )
}
